module.exports = __webpack_public_path__ + "img/scan_1.730d790e.png";